import { render } from "./FrenPabucu.vue?vue&type=template&id=02ee8c74"
import script from "./FrenPabucu.vue?vue&type=script&lang=js"
export * from "./FrenPabucu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__